import { TagDataLayer, getPathnameUrl } from '@axa-fr-axion/tag';
import { StepNavigationPath } from 'interfaces';

const getPageUrl = (etape: string, statusClient?: string) => {
    const status = statusClient === 'prospect' ? 'prospect' : 'client';

    return getPathnameUrl(`${ etape }/${ status }`);
};

export const DATA_LAYER_GLOBAL: Omit<TagDataLayer, 'xiti_xtpage'> = {
    page_univers: 'auto',
    nom_site: 'new_quickquote_auto',
    // INFO: This value will differ depending on the visitor.
    statut_client: 'prospect',
};
export const getTagData = (
    statusClient?: string
): Record<StepNavigationPath, TagDataLayer | null> => {
    return {
        VehicleIdentificationChoice: {
            xiti_xtpage: 'new_quickquote_auto::etape_1_besoin::choix_immat_modele',
            nom_etape: 'etape_1_besoin/choix_immat_modele',
            sollicitation: 0,
            num_etape: 1,
            page_erreur: 0,
        },
        LicensePlateIdentification: {
            xiti_xtpage: 'new_quickquote_auto::etape_1_besoin::q1_immat',
            nom_etape: 'etape_1_besoin/q1_immat',
            sollicitation: 0,
            num_etape: 1,
            page_erreur: 0,
        },
        BrandIdentification: {
            xiti_xtpage: 'new_quickquote_auto::etape_1_besoin::q3_selection_marque',
            nom_etape: 'etape_1_besoin/q3_selection_marque',
            sollicitation: 0,
            num_etape: 1,
            page_erreur: 0,
        },
        ModelIdentification: {
            xiti_xtpage: 'new_quickquote_auto::etape_1_besoin::q4_selection_modele',
            nom_etape: 'etape_1_besoin/q4_selection_modele',
            sollicitation: 0,
            num_etape: 1,
            page_erreur: 0,
        },
        CirculationDate: {
            xiti_xtpage: 'new_quickquote_auto::etape_1_besoin::q2_date_mise_circulation',
            nom_etape: 'etape_1_besoin/q2_date_mise_circulation',
            sollicitation: 0,
            num_etape: 1,
            page_erreur: 0,
        },
        BodyType: {
            xiti_xtpage: 'new_quickquote_auto::etape_1_besoin::q5_selection_carrosserie',
            nom_etape: 'etape_1_besoin/q5_selection_carrosserie',
            sollicitation: 0,
            num_etape: 1,
            page_erreur: 0,
        },
        MotorizationType: {
            xiti_xtpage: 'new_quickquote_auto::etape_1_besoin::q6_selection_motorisation',
            nom_etape: 'etape_1_besoin/q6_selection_motorisation',
            sollicitation: 0,
            num_etape: 1,
            page_erreur: 0,
        },
        Birthdate: {
            xiti_xtpage: 'new_quickquote_auto::etape_2_profil::q7_date_de_naissance',
            nom_etape: 'etape_2_profil/q7_date_de_naissance',
            sollicitation: 0,
            num_etape: 2,
            page_erreur: 0,
        },
        Licence: {
            xiti_xtpage: 'new_quickquote_auto::etape_2_profil::q8_date_obtention_permis',
            nom_etape: 'etape_2_profil/q8_date_obtention_permis',
            sollicitation: 0,
            num_etape: 2,
            page_erreur: 0,
        },
        BonusPenaltyCoefficient: {
            xiti_xtpage: 'new_quickquote_auto::etape_2_profil::q9_bonus_malus',
            nom_etape: 'etape_2_profil/q9_bonus_malus',
            sollicitation: 0,
            num_etape: 2,
            page_erreur: 0,
        },
        InsuranceDelay: {
            xiti_xtpage: 'new_quickquote_auto::etape_2_profil::q10_date_debut_contrat',
            nom_etape: 'etape_2_profil/q10_date_debut_contrat',
            sollicitation: 0,
            num_etape: 2,
            page_erreur: 0,
        },
        Contact: {
            xiti_xtpage: 'new_quickquote_auto::etape_3_coordonnees::coordonnees',
            nom_etape: 'etape_3_coordonnees/coordonnees',
            sollicitation: 0,
            num_etape: 3,
            page_erreur: 0,
        },
        ChooseAdvisor: {
            xiti_xtpage: 'new_quickquote_auto::etape_3_coordonnees::selection_agent',
            nom_etape: 'etape_3_coordonnees/selection_agent',
            sollicitation: 0,
            num_etape: 3,
            page_erreur: 0,
        },
        Pricing: {
            xiti_xtpage: 'new_quickquote_auto::etape_4_tarif',
            nom_etape: 'etape_4_tarif/tarif',
            sollicitation: 0,
            num_etape: 4,
            page_erreur: 0,
            page_url: getPageUrl('etape_4_tarif/tarif', statusClient),
        },
        Error: {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::erreur_technique',
            nom_etape: 'etape_5_confirmation/ko/erreur_technique',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
        },
        'End/Detenteur': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::rejet',
            nom_etape: 'etape_5_confirmation/ko/rejet',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'detenteur',
            page_url: getPageUrl('etape_5_confirmation/ko/rejet', statusClient),
        },
        'End/RejetSec': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::rejet',
            nom_etape: 'etape_5_confirmation/ko/rejet',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'rejet_sec',
            page_url: getPageUrl('etape_5_confirmation/ko/rejet', statusClient),
        },
        'End/HorsMetropole': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::dom_tom',
            nom_etape: 'etape_5_confirmation/ko/dom_tom',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'hors_metropole',
            page_url: getPageUrl('etape_5_confirmation/ko/dom_tom', statusClient),
        },
        'End/Fiabilite': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::rejet',
            nom_etape: 'etape_5_confirmation/ko/rejet',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'fiabilite',
            page_url: getPageUrl('etape_5_confirmation/ko/rejet', statusClient),
        },
        'End/HorsLimite': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::hors_limite',
            nom_etape: 'etape_5_confirmation/ko/hors_limite',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'hors_limite',
            page_url: getPageUrl('etape_5_confirmation/ko/hors_limite', statusClient),
        },
        'End/AxaPartner': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::axa_part',
            nom_etape: 'etape_5_confirmation/ko/axa_part',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'axa_part',
            page_url: getPageUrl('etape_5_confirmation/ko/axa_part', statusClient),
        },
        'End/Predetenteur': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::rejet',
            nom_etape: 'etape_5_confirmation/ko/rejet',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'predetenteur',
            page_url: getPageUrl('etape_5_confirmation/ko/rejet', statusClient),
        },
        'End/HorsCible': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::hors_cible',
            nom_etape: 'etape_5_confirmation/ko/hors_cible',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'hors_cible',
            page_url: getPageUrl('etape_5_confirmation/ko/hors_cible', statusClient),
        },
        'End/Sollicitation': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::rejet',
            nom_etape: 'etape_5_confirmation/ko/rejet',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'sollicitation',
            page_url: getPageUrl('etape_5_confirmation/ko/rejet', statusClient),
        },
        'End/Personalisation': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ok::agent',
            nom_etape: 'etape_5_confirmation/ok/agent',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 0,
        },
        'End/Webcallback': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ok::csi',
            nom_etape: 'etape_5_confirmation/ok/csi',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 0,
            page_url: getPageUrl('etape_5_confirmation/ok/csi', statusClient),
        },
        'End/Abort': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ko::timeout',
            nom_etape: 'etape_5_confirmation/ko/timeout',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'timeout',
            page_url: getPageUrl('etape_5_confirmation/ko/timeout', statusClient),
        },
        'End/HorsCibleParcours': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ok::hors_cible_parcours',
            nom_etape: 'etape_5_confirmation/ok/hors_cible_parcours',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'hors_cible_parcours',
            page_url: getPageUrl('etape_5_confirmation/ok/hors_cible_parcours', statusClient),
        },
        'End/HorsCibleParcoursCSI': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_confirmation::ok::hors_cible_parcours_csi',
            nom_etape: 'etape_5_confirmation/ok/hors_cible_parcours_csi',
            sollicitation: 0,
            num_etape: 5,
            page_erreur: 1,
            rejet: 'hors_cible_parcours_csi',
            page_url: getPageUrl('etape_5_confirmation/ok/hors_cible_parcours_csi', statusClient),
        },
        'End/Consentement': {
            xiti_xtpage: 'new_quickquote_auto::etape_4_tarif::consentement',
            nom_etape: 'etape_4_tarif/consentement',
            sollicitation: 0,
            num_etape: 4,
            page_erreur: 0,
            page_url: getPageUrl('etape_4_tarif/consentement', statusClient),
        },
        'End/CSI': {
            xiti_xtpage: 'new_quickquote_auto::etape_5_tarif::ok::csi',
            nom_etape: 'etape_4_tarif/ok/csi',
            sollicitation: 0,
            num_etape: 4,
            page_erreur: 0,
            page_url: getPageUrl('etape_4_tarif/ok/csi', statusClient),
        },
    };
};
